export default "__VITE_ASSET__Da_o6r$u__"